import api from './config';
import { Risk, RiskMatrix, RiskStats } from '../types/risk';

export const riskService = {
  // Get all risks or filter by project
  getRisks: async (projectId?: number): Promise<Risk[]> => {
    const params = projectId ? { project_id: projectId } : {};
    const response = await api.get('/api/risks', { params });
    return response.data.data;
  },

  // Get a specific risk by ID
  getRisk: async (riskId: number): Promise<Risk> => {
    const response = await api.get(`/api/risks/${riskId}`);
    return response.data.data;
  },

  // Create a new risk
  createRisk: async (risk: Omit<Risk, 'id' | 'created_at' | 'updated_at'>): Promise<Risk> => {
    const response = await api.post('/api/risks', risk);
    return response.data.data;
  },

  // Update an existing risk
  updateRisk: async (riskId: number, risk: Partial<Risk>): Promise<Risk> => {
    const response = await api.put(`/api/risks/${riskId}`, risk);
    return response.data.data;
  },

  // Delete a risk
  deleteRisk: async (riskId: number): Promise<void> => {
    await api.delete(`/api/risks/${riskId}`);
  },

  // Get risk matrix data
  getRiskMatrix: async (projectId?: number): Promise<RiskMatrix> => {
    const params = projectId ? { project_id: projectId } : {};
    const response = await api.get('/api/risks/matrix', { params });
    return response.data.data;
  },

  // Calculate risk statistics
  getRiskStats: async (projectId?: number): Promise<RiskStats> => {
    const risks = await riskService.getRisks(projectId);
    
    const stats: RiskStats = {
      total: risks.length,
      identified: risks.filter(r => r.status === 'Identified').length,
      mitigated: risks.filter(r => r.status === 'Mitigated').length,
      occurred: risks.filter(r => r.status === 'Occurred').length,
      closed: risks.filter(r => r.status === 'Closed').length
    };

    return stats;
  }
};

export default riskService;